import { TFunction } from 'i18next';
import { SsoIntegrationProviderPresetEnum } from 'graphql-common';
import oktaIcon from '@lib/assets/images/sso/Okta.svg';
import googleIcon from '@lib/assets/images/sso/Google.svg';
import microsoftIcon from '@lib/assets/images/sso/Microsoft.svg';
import auth0Icon from '@lib/assets/images/sso/Auth0.svg';
import oneLoginIcon from '@lib/assets/images/sso/OneLogin.svg';
import customIcon from '@lib/assets/images/sso/Custom.svg';

export default function getProviderPresetOptions(t: TFunction) {
  return [
    {
      value: SsoIntegrationProviderPresetEnum.Okta,
      label: t('okta'),
      data: { icon: oktaIcon },
    },
    {
      value: SsoIntegrationProviderPresetEnum.Google,
      label: t('google'),
      data: { icon: googleIcon },
    },
    {
      value: SsoIntegrationProviderPresetEnum.Microsoft,
      label: t('microsoft'),
      data: { icon: microsoftIcon },
    },
    {
      value: SsoIntegrationProviderPresetEnum.Auth0,
      label: t('auth0'),
      data: { icon: auth0Icon },
    },
    {
      value: SsoIntegrationProviderPresetEnum.Onelogin,
      label: t('onelogin'),
      data: { icon: oneLoginIcon },
    },
    {
      value: SsoIntegrationProviderPresetEnum.Custom,
      label: t('custom'),
      data: { icon: customIcon },
    },
  ];
}
